import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setMasquerade } from "../store/reducers/reducer-auth";
import { selected_authentication_server } from "../deployment-config";
import axios from "../axios";
import { useSetUserLoggedIn } from "../pages/Login/LoginComp";

const TimeoutModalWithoutValidation = () => {
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const dispatch = useDispatch();
  const setUserLoggedIn = useSetUserLoggedIn();
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowTimeoutModal(true);
    }, 600000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    let countdownTimer;
    if (showTimeoutModal) {
      countdownTimer = setInterval(() => {
        setCountdown((prevCount) => prevCount - 1);
      }, 1000);
    }

    return () => clearInterval(countdownTimer);
  }, [showTimeoutModal]);

  useEffect(() => {
    if (countdown === 0) {
      const backToOrigin = async () => {
        const res2 = await axios.post(
          selected_authentication_server.access_account.endpoint,
          { userid: localStorage.getItem("backToOrigin") },
          selected_authentication_server.access_account.headers
        );
        setUserLoggedIn({ res: res2 });
        dispatch(
          setMasquerade({
            isIt: false,
            p_logged_in_email: "",
            p_session: "",
            p_ticket_id: "",
            p_customer_contact_id: ""
          })
        );
        localStorage.removeItem("backToOrigin");
      };
      backToOrigin();
    }
  }, [countdown, dispatch, setUserLoggedIn]);
  const backToOrigin = async () => {
    const res2 = await axios.post(
      selected_authentication_server.access_account.endpoint,
      { userid: localStorage.getItem("backToOrigin") },
      selected_authentication_server.access_account.headers
    );
    setUserLoggedIn({ res: res2 });
    dispatch(
      setMasquerade({
        isIt: false,
        p_logged_in_email: "",
        p_session: "",
        p_ticket_id: "",
        p_customer_contact_id: ""
      })
    );
    localStorage.removeItem("backToOrigin");
  };
  const extendSession = async () => {
    setCountdown(30);
    setShowTimeoutModal(false);
  };
  return (
    <Modal show={showTimeoutModal} onHide={() => backToOrigin()}>
      <Modal.Header closeButton>
        <Modal.Title>Session Timeout</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>You will be Back to Origin in {countdown} seconds.</p>
        <p>Do you want to continue your session?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={backToOrigin}>
          Back to Origin
        </Button>
        <Button variant="primary" onClick={extendSession}>
          Extend
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TimeoutModalWithoutValidation;
